<template>
  <div class="animated fadeIn" style="display: inline; ">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>

    <b-alert :show="dismissCountDown"
             dismissible
             style="position:relative"
             variant="success"
             @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged">
      {{ statusMsg }}
    </b-alert>


    <b-modal ref="my-modal-changes" hide-footer title="Save Changes?" data-backdrop="static" data-keyboard="false">
      <div class="d-block text-center">
        <h3>You have unsaved changes made to the partner CSV mappings for {{ partners.filter(p => p.partner_id_int === selectedPartnerID)[0].name }}.
            Would you like to save them?</h3>
      </div>
      <b-button class="mt-3" variant="outline-success" block @click="handleChanges">Save ({{yesCounter}})</b-button>
      <b-button class="mt-2" variant="outline-danger" block @click="hideModalChanges(true)">Undo</b-button>
    </b-modal>

    <b-modal ref="my-modal" hide-footer title="Save Partner CSV Mapping" data-backdrop="static" data-keyboard="false">
      <div class="d-block text-center">
        <h3>Are you sure you want to save these partner mappings for {{ partners.filter(p => p.partner_id_int === selectedPartnerID)[0].name }}?</h3>
      </div>
      <b-button class="mt-3" variant="outline-success" block @click="savePartnerCSVmappings(false)">Save ({{yesCounter}})</b-button>
      <b-button class="mt-2" variant="outline-danger" block @click="hideModal">Cancel</b-button>
    </b-modal>

    <b-modal ref="my-modal-groupUpdate" hide-footer title="Update CSV Mappings for Selected Primary Accounts">
      <div class="d-block text-center">
        <h3>
          Are you sure you want to apply {{ partners.filter(p => p.partner_id_int === selectedPartnerID)[0].name }} csv mappings to the selected primary accounts?
        </h3>
        <h5>{{String(dealershipsToUpdate).replace('[', '').replace(']','').replace('"', '').replace(",", ", ")}}</h5>
        <small>Note: Any account linked to a selected primary account may be affected.</small>
      </div>
      <b-button class="mt-3" variant="outline-success" block @click="updateDealerGroup">Save ({{yesCounter}})</b-button>
      <b-button class="mt-2" variant="outline-danger" block @click="hideModalGroupUpdate">Cancel</b-button>
    </b-modal>


    <b-card>
      <div class="row" slot="header">
        <b-col class="col-sm-1"><strong>Partner</strong></b-col>
        <b-col>
          <b-form-select style="max-width:25em; float:left" class="mr-2" v-model="selectedPartnerID" id="selectedPartnerID" v-on:change="loadPartnerCSVmappings"
                         value-field="partner_id_int" text-field="name" :options="partners">
          </b-form-select>
        </b-col>

      </div>


      <b-col lg="6" v-show="SectionRoleAccess('DMSCSVFieldMapping').visible" style="float:left; margin:0; padding:0">
        <b-card>
          <div class="row" slot="header">
            <b-col class="col-sm-8"><strong>Partner Inventory CSV Field Mappings</strong></b-col>
            <b-col class="col-sm-4">
              <button type="button" :disabled="selectedPartnerID === -1 || !unsavedChangesExist()" class="btn btn-info pull-right" v-on:click="showModal" style="min-width:0;">Save Partner Mappings</button>
            </b-col>
          </div>
          <div style="height: 462px; overflow: auto">
            <table aria-busy="false" aria-colcount="3"
                   class="table b-table table-striped table-bordered table-sm">
              <tbody>
                <tr v-for="f in partnerCSVmappings" v-bind:key="f.ID">
                  <td aria-colindex="1">{{ f.Description }}</td>
                  <td aria-colindex="2">
                    <b-form-input type="text" data-feature-code="f.ID" v-model="f.Value" :disabled="!SectionRoleAccess('DMSCSVFieldMapping').enabled"></b-form-input>
                  </td>
                  <td aria-colindex="3" v-show="SectionRoleAccess('DMSCSVFieldMapping').enabled">
                    <div style="padding-top:5px;">
                      <c-switch v-if="f.CanOverride" data-feature-code="f.ID" v-model="f.Override"
                                type="default"
                                variant="primary-outline-alt" title="Override" />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </b-card>

      </b-col>
      <b-card>
        <div class="row" slot="header">
          <b-col class="col-sm-8"><strong>Partner Accounts</strong></b-col>
          <b-col class="col-sm-4 alignRight">
            <button type="button" class="btn btn-warning" style="min-width:0;" :disabled="dealershipsToUpdate.length === 0" v-on:click="showModalGroupUpdate">
              Update CSV Mappings
            </button>
          </b-col>
        </div>
        <b-row>
          <b-col md="8" class="my-1">
            <b-form-group class="my-1">
              <b-input-group v-on:keyup.enter="submitSearch">
                <b-form-input class="mr-2" v-model="tbxFilter" id="tbxFilter" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-btn class="btn btn-success" @click="submitSearch">Search</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Main table element -->
        <div style="max-height: 343px; overflow-y: scroll">
          <b-table id="tblDealers" :items="filtered" hover striped bordered small :fields="fields" :current-page="currentPage" :per-page="perPage" class="overflow-auto"
                   :sort-compare="onSortChanged" show-empty :empty-text="emptytext">
            <template slot="accountApply" slot-scope="row">
              <input @change="chkClickHandler(row)" type="checkbox" v-model="row.value.apply">
            </template>
          </b-table>
        </div>
        <div style="height:17px"></div>
        <!-- NAV -->
        <nav>
          <b-pagination :total-rows="totalCount" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>
    </b-card>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import store from '@/store'
  import { basePageMixin } from '@/mixins/basePageMixin'
  import cSwitch from '../components/Switch'
  import moment from 'moment'
  import { DxDropDownBox, DxTreeView } from "devextreme-vue";
  import CustomStore from "devextreme/data/custom_store";

  export default {

    components: {
      loading,
      cSwitch
    },

    mixins: [basePageMixin],

    data() {
      return {
        errMsg: '',
        statusMsg: '',
        dismissSecs: 5,
        dismissCountDown: 0,
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        yesCounter: 3,
        boolLoading: false,
        txtLoading: 'Loading...',
        users: [],
        partners: [{ 'partner_id_int': -1, 'name': 'Select a Partner' }],
        filterShowActiveUsersOnly: true,
        totalCount: 0,
        selectedPartnerID: -1,
        tbxFilter: '',
        originalPartnerCSVmappings: [],
        partnerCSVmappings: [],
        filter: '',
        totalRows: 0,
        role: 'User',
        FormRolePermissions: [{
          role: 'PM',
          sections: [
            {
              section: 'DMSCSVFieldMapping',
              visible: false,
              enabled: false
            }
          ]
        }],

        treeBoxValue: [],
        ddAccountStatus: 0,
        ddAccountType: 0,
        ddState: 0,
        totalCount: 0,
        tbxFilter: '',
        items: [],
        filtered: [],
        dealershipsToUpdate: [],
        fields: [
          { key: 'primary_account', label: 'Primary #', sortable: true },
          { key: 'account', label: 'Account #', sortable: true },
          { key: 'name', label: 'Dealership Name', sortable: true },
          { key: 'accountApply', label: 'Apply?', sortable: true }
        ],
        currentPage: 1,
        perPage: 15,
        SelFeatures: true,
        emptytext: 'Please search for accounts',
        emptytextprimary: 'Add an account from the above form',

        onSortChanged(a, b, key) {
          var a1
          var b1
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            if (key === 'accountApply') {
              a1 = ((a[key]['apply'] + '').toLowerCase().trim() === 'true') ? 1 : 0
              b1 = ((b[key]['apply'] + '').toLowerCase().trim() === 'true') ? 1 : 0
              return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
            }
            a1 = (a[key] + '')
            b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }

        }

      }
    },

    created() {
      let self = this
      self.role = store.state.currentRole;
      self.fetchData()

      setTimeout(function () {
        self.toggleloader(false)
      }, 500)

    },

    methods: {
      SectionRoleAccess(section) {
        let self = this;
        if (store.state.currentRole != 'Admin' || store.state.currentRole != 'User') {
          let rolePermisions = self.FormRolePermissions.filter(x => x.role == store.state.currentRole);
          if (rolePermisions.length > 0) {
            let sectionpermission = rolePermisions[0].sections.filter(x => x.section == section);
            if (sectionpermission.length > 0)
              return sectionpermission[0];
          }
        }
        return {
          visible: true,
          enabled: true
        };
      },
      fetchData() {
        axios.get('/api/PartnersAPI/GetPartners')
          .then(response => {
            this.boolLoading = false
            this.partners = response.data.PARTNERS
            this.totalCount = this.partners.length
           // this.loadPartnerCSVmappings()
          })
          .catch(error => {
            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          })
      },

      loadPartnerCSVmappings() {
        this.boolLoading = true
        let obj = {
          partner_id_int: this.selectedPartnerID
        }
        axios.post('/api/PartnersAPI/LoadPartnerInventoryCSVmapping', obj)
          .then(response => {
            this.partnerCSVmappings = response.data.partnerCSVmappings
            this.originalPartnerCSVmappings = JSON.parse(JSON.stringify(response.data.partnerCSVmappings))
            this.boolLoading = false
            this.tbxFilter = ''
            

          })
          .catch(error => {
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
            this.boolLoading = false
          })

        this.submitSearch()

      },

      savePartnerCSVmappings(bypassCounter) {
        if (this.yesCounter > 1 && !bypassCounter) {
          this.yesCounter -= 1
          return this.showModal()
        }
        this.yesCounter = 3
        this.boolLoading = true
        let obj = {
          partner_id_int: this.selectedPartnerID,
          partner_csv_mappings: this.partnerCSVmappings
        }
        axios.post('/api/PartnersAPI/UpdatePartnerInventoryCSVmapping', obj)
          .then(response => {
            this.statusMsg = 'New Partner Mappings Successfully Saved'
            this.originalPartnerCSVmappings = JSON.parse(JSON.stringify(this.partnerCSVmappings))
            this.showAlert()
            this.boolLoading = false
            
          })
          .catch(error => {
            this.errMsg = 'There was an error saving data : ' + error
            this.showDismissibleAlert = true
            this.boolLoading = false
          })
        this.hideModal()
      },

      updateDealerGroup() {
        if (this.yesCounter > 1) {
          this.yesCounter -= 1
          return this.showModalGroupUpdate()
        }
        this.yesCounter = 3

        this.boolLoading = true

        let obj = {
          PrimaryAccounts: this.dealershipsToUpdate,
          PartnerMappings: this.partnerCSVmappings
        }

        axios.post('/api/PartnersAPI/UpdateDealerGroup', obj)
          .then(response => {
            this.boolLoading = false
            this.statusMsg = 'Primary Accounts Have Been Updated'
            this.showAlert()
          })
          .catch(error => {
            this.errMsg = 'There was an error saving data : ' + error
            this.showDismissibleAlert = true
            this.boolLoading = false
          })

        this.hideModalGroupUpdate()
      },

      unsavedChangesExist() {
        let diffFound = false
        let a = this.partnerCSVmappings
        let b = this.originalPartnerCSVmappings
        for (var i = 0; i < this.partnerCSVmappings.length; i++) {
          if (a[i].Value !== b[i].Value || a[i].Override !== b[i].Override) {
            diffFound = true;
            break;
          }
        }
        if (diffFound) {
          return true
        }
        return false
      },

      handleChanges() {
        if (this.yesCounter > 1) {
          this.yesCounter -= 1
          return this.showModalChanges()
        }
        this.yesCounter = 3
        this.hideModalChanges(false)
        this.savePartnerCSVmappings(true)
      },

      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },

      showAlert() {
        this.dismissCountDown = this.dismissSecs
      },

      showModal() {
        this.$refs['my-modal'].show()
      },

      hideModal() {
        this.$refs['my-modal'].hide()
        this.yesCounter = 3
      },

      showModalGroupUpdate() {
        if (this.unsavedChangesExist()) {
          this.yesCounter = 4
          return this.handleChanges()
        }
          
        this.$refs['my-modal-groupUpdate'].show()
      },

      hideModalGroupUpdate() {
        this.$refs['my-modal-groupUpdate'].hide()
        this.yesCounter = 3
      },

      showModalChanges() {
         this.$refs['my-modal-changes'].show()
      },

      hideModalChanges(undoChanges) {
        this.$refs['my-modal-changes'].hide()
        this.yesCounter = 3
        if (undoChanges) {
          this.partnerCSVmappings = JSON.parse(JSON.stringify(this.originalPartnerCSVmappings))
        }
      },

      chkClickHandler(row) {
        let self = this
        let pAccount = row.value.pAccount
        let apply = row.value.apply
        var duplicate = self.dealershipsToUpdate.filter(p => p === pAccount)
        if (duplicate.length === 0 && pAccount.length > 0 && apply) {
          self.dealershipsToUpdate.push(pAccount)
        }
        if (duplicate.length > 0 && !apply) {
          self.dealershipsToUpdate = self.dealershipsToUpdate.filter(p => p !== pAccount)
          self.filtered.filter(acc => acc.primary_account === pAccount).forEach(acc => acc.accountApply.apply = false)
        }
      },

      getRowCount() {
        let self = this

        let itemsCount = self.filtered.length;// self.items.length
        let totalpages = Math.ceil(itemsCount / self.perPage)
        let totalfullpages = Math.floor(itemsCount / self.perPage)

        if (itemsCount === 0 || itemsCount < self.perPage) {
          return itemsCount
        } else if (self.currentPage < totalpages) {
          return self.perPage
        }
        return itemsCount - totalfullpages * self.perPage
      },

      submitSearch() {
        this.dealershipsToUpdate = []
        let self = this
        this.boolLoading = true
        let obj = {
          partner_id_int: this.selectedPartnerID,
          account_number: this.tbxFilter
        }
        axios.post('/api/PartnersAPI/LoadPartnerDealerships', obj)
          .then(response => {
            response.data.PARTNER_DEALERSHIPS.forEach(d => {
              d["accountApply"] = { apply: false, pAccount: d.primary_account }
            })
            self.filtered = self.items = response.data.PARTNER_DEALERSHIPS
            self.totalCount = self.items.length;
            self.emptytext = 'There are no accounts to show'
          })
          .catch(error => {
            self.handleError(error)
          }).then(r => {
            this.boolLoading = false
          })
      }

    },

    mounted() {
      // boolLoading must be set to false on data() binding so that mount hooks the change
      this.boolLoading = true
    }
  }
</script>

<style>
  .close {display: none;}
</style>



// WEBPACK FOOTER //
// src/views/PartnerLevelMappings.vue